import React, { useState, useEffect } from "react"
import {
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  Card,
  CardTitle,
  Form,
  Label,
  Input,
  Button,
  Table,
  Modal,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import toast, { Toaster } from "react-hot-toast"
import ReactPaginate from "react-paginate"
import { addData, getAllData, updateData, deletedData } from "Servicescalls"

const Eventgallery = () => {
  const [modal_small, setmodal_small] = useState(false)

  function tog_small() {
    setmodal_small(!modal_small)
  }

  const [User, setUser] = useState([])
  const [form, setform] = useState([])
  const [form1, setform1] = useState([])

  const GetAll = async () => {
    const resonse = await getAllData("deliveryBoy/getAll")
    console.log(resonse)
    var _data = resonse
    setUser(_data.data.data)
  }

  const Add = async () => {
    const dataArray = {
      firstName: form.firstName,
      lastName: form.lastName,
      phone: form.phone,
      email: form.email,
    }
    try {
      const resonse = await addData("deliveryBoy/create", dataArray)
      var _data = resonse
      setform({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
      })
      toast(_data.data.message)
      GetAll()
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message)
      } else {
        toast.error("An error occurred. Please try again.")
      }
    }
  }

  const handleChange = e => {
    let myUser = { ...form }
    myUser[e.target.name] = e.target.value
    setform(myUser)
  }

  const Edit = async e => {
    const bodydata = {
      firstName: form1.firstName,
      lastName: form1.lastName,
      email: form1.email,
      phone: form1.phone,
      // bannerId:form1.bannerId
    }
    try {
      const response = await updateData(
        "deliveryBoy/edit/" + form1._id,
        bodydata
      )
      var _data = response.data
      console.log(_data)
      toast.success(_data.message)
      tog_small()
      GetAll()
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message)
      } else {
        toast.error("An error occurred. Please try again.")
      }
    }
  }

  const handleChange1 = e => {
    let myUser = { ...form1 }
    myUser[e.target.name] = e.target.value
    setform1(myUser)
  }

  const getpopup = data => {
    setform1(data)
    tog_small()
  }

  const handleSubmit = e => {
    e.preventDefault()
    Add()
  }

  const handleSubmit1 = e => {
    e.preventDefault()
    Edit()
  }

  const deletebenners = async data => {
    try {
      const resonse = await deletedData("deliveryBoy/delete/" + data._id)
      var _data = resonse
      toast(_data.data.message)
      GetAll()
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message)
      } else {
        toast.error("An error occurred. Please try again.")
      }
    }
  }

  const manageDelete = data => {
    const confirmBox = window.confirm("Do you really want to Delete?")
    if (confirmBox === true) {
      deletebenners(data)
    }
  }

  const manageDeletes = data => {
    const confirmBox = window.confirm("Do you really want to InActive?")
    if (confirmBox === true) {
      Delete(data)
    }
  }

  const Delete = async data => {
    const dataArray = { dishId: data._id, status: "inactive" }
    try {
      const resonse = await addData("dish/dishUpdateStatus", dataArray)
      var _data = resonse
      toast.success(_data.data.message)
      GetAll()
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message)
      }
    }
  }

  const manageDelete1 = data => {
    const confirmBox = window.confirm("Do you really want to Active?")
    if (confirmBox === true) {
      Delete1(data)
    }
  }

  const Delete1 = async data => {
    const dataArray = { dishId: data._id, status: "active" }
    try {
      const resonse = await addData("dish/dishUpdateStatus", dataArray)
      var _data = resonse
      toast.success(_data.data.message)
      GetAll()
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message)
      }
    }
  }

  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  const pagesVisited = pageNumber * listPerPage
  const lists = User.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(User.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  useEffect(() => {
    GetAll()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Hasini Enterprises"
            breadcrumbItem="Delivery Boy"
          />

          <Row>
            <Col md={4}>
              <Card>
                <CardHeader className="bg-white">
                  <CardTitle>Add Details</CardTitle>
                </CardHeader>
                <CardBody>
                  <Form
                    onSubmit={e => {
                      handleSubmit(e)
                    }}
                  >
                    <Row>
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          First Name <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="basicpill-firstname-input1"
                          placeholder="Enter First Name"
                          required
                          name="firstName"
                          value={form.firstName}
                          onChange={e => {
                            handleChange(e)
                          }}
                        />
                      </div>
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          Last Name <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="basicpill-firstname-input1"
                          placeholder="Enter Last Name"
                          required
                          name="lastName"
                          value={form.lastName}
                          onChange={e => {
                            handleChange(e)
                          }}
                        />
                      </div>
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">Email</Label>
                        <Input
                          type="email"
                          className="form-control"
                          id="basicpill-firstname-input1"
                          placeholder="Enter Email"
                          name="email"
                          value={form.email}
                          onChange={e => {
                            handleChange(e)
                          }}
                        />
                      </div>
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input2">
                          Mobile Number
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="tel"
                          className="form-control"
                          id="basicpill-firstname-input2"
                          required
                          placeholder="Enter Mobile Number"
                          name="phone"
                          value={form.phone}
                          minLength="10"
                          maxLength="10"
                          onChange={e => {
                            handleChange(e)
                          }}
                        />
                      </div>
                    </Row>

                    <div className="mt-4" style={{ float: "right" }}>
                      <Button className="m-1" color="success" type="submit">
                        Submit <i className="fas fa-check-circle"></i>
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>

            <Col md={8}>
              <Card>
                <CardBody>
                  <div>
                    <div className="table-responsive">
                      <Table className="table table-bordered mb-4 mt-3">
                        <thead>
                          <tr>
                            <th>S No</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email</th>
                            <th>Mobile Number</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lists.map((data, key) => (
                            <tr key={key}>
                              <td>{(pageNumber - 1) * 5 + key + 6}</td>
                              <td>{data.firstName}</td>
                              <td>{data.lastName}</td>
                              <td>{data.email}</td>
                              <td>{data.phone}</td>
                              <td>
                                <Button
                                  onClick={() => {
                                    getpopup(data)
                                  }}
                                  className="mr-2"
                                  style={{ padding: "6px", margin: "3px" }}
                                  color="success"
                                  outline
                                >
                                  <i className="bx bx-edit "></i>
                                </Button>
                                <Button
                                  onClick={() => {
                                    manageDelete(data)
                                  }}
                                  style={{ padding: "6px", margin: "3px" }}
                                  color="danger"
                                  outline
                                >
                                  <i className="bx bx-trash"></i>
                                </Button>

                                {/* {data.status == "active" ? (
                                  <Button
                                    onClick={() => {
                                      manageDeletes(data)
                                    }}
                                    outline
                                    style={{ padding: "6px", margin: "3px" }}
                                    color="danger"
                                  >
                                    <i className="fas fa-user-lock"></i>
                                  </Button>
                                ) : (
                                  <Button
                                    onClick={() => {
                                      manageDelete1(data)
                                    }}
                                    outline
                                    style={{ padding: "6px", margin: "3px" }}
                                    color="success"
                                  >
                                    <i className="fas fa-user-check"></i>
                                  </Button>
                                )} */}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>

                      <div className="mt-3" style={{ float: "right" }}>
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={"pagination"}
                          previousLinkClassName={"previousBttn"}
                          nextLinkClassName={"nextBttn"}
                          disabledClassName={"disabled"}
                          activeClassName={"active"}
                          total={lists.length}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Modal
          size="md"
          centered
          isOpen={modal_small}
          toggle={() => {
            tog_small()
          }}
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="mySmallModalLabel">
              Edit Details
            </h5>
            <button
              onClick={() => {
                setmodal_small(false)
              }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form
              onSubmit={e => {
                handleSubmit1(e)
              }}
            >
              <Row>
                {" "}
                <Col md="12">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      First Name <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      placeholder="Enter First Name"
                      required
                      name="firstName"
                      value={form1.firstName}
                      onChange={e => {
                        handleChange1(e)
                      }}
                    />
                  </div>{" "}
                </Col>
                <Col md="12">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Last Name <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      placeholder="Enter Last Name"
                      required
                      name="lastName"
                      value={form1.lastName}
                      onChange={e => {
                        handleChange1(e)
                      }}
                    />
                  </div>{" "}
                </Col>
                <Col md="12">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">Email</Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      placeholder="Enter Email"
                      name="email"
                      value={form1.email}
                      onChange={e => {
                        handleChange1(e)
                      }}
                    />
                  </div>{" "}
                </Col>
                <Col md="12">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Mobile Number
                      <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="tel"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      placeholder="Enter Mobile Number"
                      required
                      name="phone"
                      value={form1.phone}
                      minLength="10"
                      maxLength="10"
                      onChange={e => {
                        handleChange1(e)
                      }}
                    />
                  </div>{" "}
                </Col>
                <Col md="12">
                  <div className="mb-3">
                    <Label for="status-select">
                      Status
                      <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="select"
                      id="status-select"
                      name="status"
                      value={form1.status}
                      onChange={e => {
                        handleChange1(e)
                      }}
                    >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </Input>
                  </div>
                </Col>
              </Row>

              <div style={{ float: "right" }}>
                <Button
                  onClick={() => {
                    setmodal_small(false)
                  }}
                  color="danger"
                  type="button"
                >
                  Cancel <i className="fas fa-times-circle"></i>
                </Button>
                <Button className="m-1" color="success" type="submit">
                  Submit <i className="fas fa-check-circle"></i>
                </Button>
              </div>
            </Form>
          </div>
        </Modal>

        <Toaster />
      </div>
    </React.Fragment>
  )
}

export default Eventgallery
